(function initTacCustomizerTrigger(global, doc) {
  "use strict";

  const VERSION = "8.12d.2";
  const diagnostics = global.TACCustomizerTriggerDiagnostics ||= {
    version: VERSION,
    loadedAt: new Date().toISOString(),
    clickCount: 0,
    lastClick: null,
  };
  diagnostics.version = VERSION;

  if (!global || !doc || global.__tacCustomizerTriggerBound) return;
  global.__tacCustomizerTriggerBound = true;

  doc.addEventListener("click", function onTacCustomizerTriggerClick(event) {
    const path = typeof event.composedPath === "function" ? event.composedPath() : [];
    const pathTrigger = path.find(function findTacTrigger(node) {
      return node && typeof node.matches === "function" && node.matches("[data-tac-open-customizer]");
    });
    const target = event && event.target;
    const element = target && typeof target.closest === "function"
      ? target
      : target && target.parentElement;
    const trigger = pathTrigger || (
      element && typeof element.closest === "function"
        ? element.closest("[data-tac-open-customizer]")
        : null
    );

    if (!trigger) return;

    const clickedAt = typeof global.performance?.now === "function" ? global.performance.now() : Date.now();
    global.TACUXMetrics ||= {};
    global.TACUXMetrics.ctaClick = clickedAt;
    global.TACTrace?.("CTA_CLICK");

    diagnostics.clickCount += 1;
    diagnostics.lastClick = {
      targetTag: target && target.nodeName ? target.nodeName : null,
      matched: true,
      disabled: trigger.disabled === true || trigger.getAttribute("aria-disabled") === "true",
      openerType: typeof global.TACOpenCustomizer,
      invoked: false,
    };
    if (typeof global.TACTrace === "function") {
      global.TACTrace("CTA_RECEIVED", {
        disabled: diagnostics.lastClick.disabled,
        openerType: diagnostics.lastClick.openerType,
      });
    }

    if (diagnostics.lastClick.disabled) return;

    const openCustomizer = global.TACOpenCustomizer;
    if (typeof openCustomizer !== "function") return;

    const viewportWidth = Math.max(Number(global.innerWidth) || 0, 1);
    const viewportHeight = Math.max(Number(global.innerHeight) || 0, 1);
    const clientX = Number(event.clientX);
    const clientY = Number(event.clientY);

    diagnostics.lastClick.invoked = true;
    openCustomizer(
      Number.isFinite(clientX) && clientX > 0 ? (clientX / viewportWidth) * 100 : 50,
      Number.isFinite(clientY) && clientY > 0 ? (clientY / viewportHeight) * 100 : 50
    );
  }, { capture: true });
})(window, document);
